<template>
    <div class="d-flex align-items-center">
        <b-button class="mr-2" v-if="showEditButton" title="Edit" variant="outline-primary" @click="updateBill">
            <font-awesome-icon :icon="['fas', 'pen-to-square']"></font-awesome-icon>
        </b-button>
        <b-button
            v-if="showDeleteButton"
            title="Delete"
            variant="outline-primary"
            @click="$bvModal.show(deleteBillConfirmModalId)"
            :disabled="!reservationEdit"
        >
            <busy-modal :show="loading"></busy-modal>
            <font-awesome-icon :icon="['fas', 'xmark']" />
        </b-button>
        <reservation-payment-modal
            :modal-id="paymentModalId"
            :initial-values="reservation"
            :onUpdate="onBillUpdate"
            :isStatic="false"
            :bill="params.data"
            :type="billType"
            :mode="billMode"
        />
        <modal :id="deleteBillConfirmModalId" :title="`Delete ${billTypeText}`" @ok="deleteBill">
            <p>Are you sure you want to delete this {{ billTypeText }}.</p>
        </modal>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import API from '../../../../../api.jsx';
import Modal from '../../../../generic/modal/modal.vue';
import BusyModal from '../../../../generic/busy-modal/busy-modal.vue';
import ReservationPaymentModal from '../../../../common/reservation-payment-modal.vue';
import { BILL_TYPE_MAPPING } from '../../../../../constants';
import { formatResponseError } from '../../../../../utils/api';
import { RESERVATION_INVOICE_DELETE_BILL_ENDPOINT } from '../../../../../endpoints.js';

export default {
    components: { Modal, BusyModal, ReservationPaymentModal },
    data() {
        return {
            loading: false,
            billType: 0,
            billMode: 'UPDATE',
            paymentModalId: null,
            deleteBillConfirmModalId: null,
        };
    },
    inject: ['showSuccessToast', 'showErrorToast'],
    created() {
        this.billType = this.params.data.type;
        this.paymentModalId = `payment-modal-id-${this.params.data.id}`;
        this.deleteBillConfirmModalId = `delete-bill-confirm-id-${this.params.data.id}`;
    },
    computed: {
        ...mapGetters('guest', ['metadata', 'reservation']),
        reservationEdit() {
            return this.metadata?.permissions?.reservation_edit;
        },
        guestId() {
            return parseInt(this.$route.params.id);
        },
        showEditButton() {
            return (
                !this.params.data.hide &&
                this.params.data.payment_method !== 4 &&
                this.params.data.payment_method !== 9 &&
                this.metadata.permissions.reservation_edit &&
                this.metadata.permissions.billing_process &&
                this.metadata.permissions.transactions_view &&
                this.params.data.status !== 0
            );
        },
        showDeleteButton() {
            return (
                !this.params.data.hide &&
                this.metadata.permissions.reservation_edit &&
                this.metadata.permissions.transactions_view &&
                this.params.data.status !== 0
            );
        },
        billTypeText() {
            return BILL_TYPE_MAPPING[this.billType];
        },
    },
    methods: {
        updateBill() {
            this.$bvModal.show(this.paymentModalId);
        },
        deleteBillConfirm() {
            this.$bvModal.show(this.deleteBillConfirmModalId);
        },
        onBillUpdate(message) {
            this.params.refreshReservation(() => this.showSuccessToast({ text: message }));
        },
        async deleteBill() {
            this.loading = true;
            try {
                await API.delete(RESERVATION_INVOICE_DELETE_BILL_ENDPOINT(this.reservation.id), {
                    data: { id: this.params.data.id },
                });
                this.params.refreshReservation(() =>
                    this.showSuccessToast({ text: `${BILL_TYPE_MAPPING[this.billType]} successfully deleted.` })
                );
            } catch (err) {
                const { generic } = formatResponseError(err);
                this.showErrorToast({
                    text: generic || `Could not delete ${BILL_TYPE_MAPPING[this.billType]}.`,
                });
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
:deep(.btn) {
    min-width: 2.7rem !important;
}
:deep(.btn:focus) {
    box-shadow: none !important;
}
</style>
